/**
 * DURUM SAYFASI
 *
 * Kimlik ISTEMEZ. Musterinin "sorun bende mi, sizde mi" sorusuna cevap verir.
 * Bilincli olarak kabadir: sayac, adres, musteri sayisi yoktur.
 */
import { api } from "../api";
import { Durum, Kart, useCek } from "../ui";
import { Logo, UrunAdi } from "../marka";

export function DurumSayfasi() {
  const d = useCek(() => api.acikDurum(), []);

  return (
    <div className="giris-sayfa">
      <div className="giris-kutu" style={{ maxWidth: 520 }}>
        <div className="marka">
          <Logo boyut={26} />
          <UrunAdi />
        </div>
        <h1>Sistem durumu</h1>

        <Durum cekim={d}>
          {(y) => {
            const v = y.veri;
            const renk = v.durum === "calisiyor" ? "var(--ok)" : v.durum === "kismi" ? "var(--warn)" : "var(--bad)";
            const metin =
              v.durum === "calisiyor"
                ? "Bütün sistemler çalışıyor"
                : v.durum === "kismi"
                  ? "Bazı bölümlerde kesinti var"
                  : "Yaygın kesinti";
            return (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "14px 0",
                    borderBottom: "1px solid var(--n-200)",
                  }}
                >
                  <span
                    style={{ width: 12, height: 12, borderRadius: "50%", background: renk, flexShrink: 0 }}
                    aria-hidden
                  />
                  <strong style={{ fontSize: 16 }}>{metin}</strong>
                </div>

                {v.bilesenler.map((b) => (
                  <div
                    key={b.ad}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      padding: "11px 0",
                      borderBottom: "1px solid var(--n-200)",
                    }}
                  >
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: b.durum === "calisiyor" ? "var(--ok)" : "var(--bad)",
                        flexShrink: 0,
                      }}
                      aria-hidden
                    />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 600 }}>{b.ad}</div>
                      <div style={{ fontSize: 12.5, color: "var(--n-500)" }}>{b.aciklama}</div>
                    </div>
                  </div>
                ))}

                <p className="giris-dip">
                  Son kontrol: {new Date(v.zaman).toLocaleString("tr-TR")}
                  <br />
                  Burada her şey yeşilken sorun yaşıyorsanız kendi bağlantınızı ve posta
                  programınızın ayarlarını kontrol edin.
                  <br />
                  <a href="#/">← Panele dön</a>
                </p>
              </>
            );
          }}
        </Durum>
      </div>
    </div>
  );
}
